import React, { FC } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { TagProps } from "@UI/Components/Tag/Tag";
import { SuggestionBadge } from "../SuggestionBadge/SuggestionBadge";
import messages from "./messages";

export type AutoFilledBadgeProps = Omit<TagProps, "children">;

/**
 * Standalone "this value came from AI" flag — one fixed, translated wording used
 * everywhere a question needs to flag an auto-filled/suggested value, instead of
 * each call site passing its own ad-hoc string (previously "Assistant suggests" vs
 * "Auto-filled from your description").
 */
export const AutoFilledBadge: FC<AutoFilledBadgeProps> = (props) => (
  <SuggestionBadge {...props}>
    <FormattedMessage {...messages.label} />
  </SuggestionBadge>
);
